import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Landing } from "../Screens/Landing/index";
// import { Login } from "../Views/Auth/Login";
// import { Default } from "../Views/Default/Index";
// import { Welcome } from "../Views/Auth/index";
// import { Register } from "../Views/Auth/Register";
// import { VerifyOtp } from "../Views/Auth/VerifyOtp";
// import { Overview } from "../Views/Dashboard/index";
// import { CompleteProfile } from "../Views/Auth/Complete-Profile";
// import { SearchResults } from "../Views/Search/Index";
// import { SearchResponseSelection } from "../Views/Search/search-selection";
// import { ArtisanDetails } from "../Views/Search//artisan-details";

export default function AppRouter(props) {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Landing} />
        {/* <Route path="/login" exact component={Login} />
        <Route path="/home" exact component={Default} />
        <Route path="/welcome" exact component={Welcome} />
        <Route path="/register" exact component={Register} />
        <Route path="/verify-otp" exact component={VerifyOtp} />
        <Route path="/overview" exact component={Overview} />
        <Route path="/complete-profile" exact component={CompleteProfile} />
        <Route path="/search-type" exact component={SearchResults} />
        <Route path="/service-artisan" exact component={SearchResponseSelection} />

        <Route path="/artisan-details" exact component={ArtisanDetails} /> */}

      </Switch>
    </Router>
  );
}
